<template lang="pug">
  RollInfoPanel
    .review-and-activate
      h1 Review and Activate
      .row
        .col-sm-12
          .row
            .col-sm-6
              .form-group
                label Product
                .input
                  ProductSelect(v-model="productId" :disabled="true")
              .form-group
                label Schema
                .input
                  select.form-control(v-model="selectedSchemaId" :disabled="true")
                    option(v-for="schema in schemas" :value="schema.id") {{schema.name}}
            .col-sm-6
              .form-group(v-if="selectedSchemaId")
                label Metadata
                .loading(v-if="schemaLoading") Loading...
                .metadata-editor-wrap(v-else)
                  MetadataEditor(:schema="schema" :metadata="metadata" :disabled="true")

        .col-sm-6.col-sm-offset-6.activation-time
          label Activation time
          .panel.panel-default
            .panel-body
              div
                input#activate-now(type="radio" v-model="activateNow" v-bind:value="true" @click="activationDateError=''")
                label(for="activate-now") activate now
              div
                input#activate-later(type="radio" v-model="activateNow" v-bind:value="false" @click="activationDateError=''")
                label(for="activate-later") activate at specific time
              .date-pick-wrap(v-if="!activateNow")
                .input
                  Datepicker(v-model="activationDate" v-bind:timePicker="true" placeholder="Pick an activation time")
              .alert.alert-danger(v-if="activationDateError") {{activationDateError}}
        .col-sm-12
          .activate-button.text-right
            SspActionButton.btn-lg(@onClick="activate()" :spinning="activating" text="Activate")
</template>
<script>
import MetadataEditor from '@/components/metadataeditor/MetadataEditor'
import ProductSelect from '@/components/ssp/ProductSelect'
import Datepicker from '@/components/common/Datepicker'
import RollInfoPanel from '../components/RollInfoPanel'
import activationSession from '../service/ActivationSession'

export default {
  created() {
    activationSession
      .getMetadataSchemas()
      .then((resp) => {
        this.schemas = resp.data.schema
      })
      .catch((e) => { this.$emit('error', e) })

    this.selectedSchemaId = activationSession.getSchemaAndData().schemaId
    this.metadata = activationSession.getSchemaAndData().metadata

    this.schemaLoading = true
    activationSession
      .getSchemaById(this.selectedSchemaId)
      .then((resp) => {
        this.schema = resp.data
      })
      .catch((e) => {
        this.$emit('error', e)
      })
      .then(() => {
        this.schemaLoading = false
      })
  },
  data: () => ({
    activating: false,
    productId: activationSession.getProduct(),
    selectedSchemaId: null,
    metadata: {},
    activateNow: true,
    activationDate: '',
    activationDateError: '',
    schemas: [],
    schema: {},
    schemaLoading: false
  }),
  methods: {
    activate() {
      const data = {
        productId: this.productId,
        schemaId: this.selectedSchemaId,
        metadata: this.metadata
      }
      if (!this.activateNow) {
        if (!this.activationDate) {
          this.activationDateError = 'Please select activation date, or use "Activate Now"'
          return
        }
        const activationDate = new Date(this.activationDate)
        if (new Date() > activationDate) {
          this.activationDateError = 'Please select activation date in future, or use "Activate Now"'
          return
        }
        data.activationDate = activationDate
      }
      this.$emit('activate', data)
    }
  },
  components: {
    ProductSelect,
    RollInfoPanel,
    MetadataEditor,
    Datepicker
  }
}
</script>

<style>
  .activation-time input[type="radio"] {
    margin-right: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/activator/wiz/Activate.vue